import React from "react";
import Logo from "../../../Logo/Logo";
import "./AdminHeader.scss";

const AdminHeader = ({ client, onGoHome, onLogout }) => {
  return (
    <div className="admin-dashboard__header">
      <div className="header-content">
        <div className="left">
          <a
            href="https://blueprintnyc.com"
            target="_blank"
            rel="noopener noreferrer"
            className="blueprint-logo"
          >
            <Logo client="blueprint" />
          </a>
        </div>
        <div className="right">
          {client !== "blueprint" && <Logo client={client} />}
          <button className="btn btn-outline" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
